import React from 'react'
import { buildImageObj } from '../lib/helpers'
import { imageUrlFor } from '../lib/image-url'

import BlockContent from './block-content'
import NextPrev from './nextprev'

import styled from 'styled-components'
import ContentTag from './content-tag'

const totalWidth = 900

const Header = styled.header`
  display: grid;
  grid-template-columns: minmax(60px, auto) 7fr 60px 6fr minmax(60px, auto);
  min-height: 80vh;

  @media only screen and (min-width: ${totalWidth}px) {
    > * {
      transform: translateY(10vh);
    }
    
  }

  @media only screen and (max-width: ${totalWidth}px) {
    display: flex;
    flex-direction: column;
    flex-wrap: reverse;
    width: 100%;
    min-height: 0px;
    margin-top: 30px;

    #header-info{
      margin: 0 60px;
    }

    h1 {
      padding-bottom: 0 !important;
    }

    #description {
      border-top: 0 !important;
      padding-bottom: 20px;
      border-bottom: 1px solid #dfdfdf;
    }
  }

  img {
    grid-column: 4;
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: 2;
    box-shadow: 3px 5px 5px rgba(0, 0, 0, 0.2);
  }

  #header-info {
    grid-column: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h1 {
        font-size: calc(2em + 2vw);
        font-family: 'Playfair-display', serif;
        font-weight: 600;
        margin-bottom: 0px;
        line-height: 1em;
        padding-bottom: 20px;
      }

      #description {
        border-top: 1px solid #dfdfdf;
        font-size: 1.2em; 
        p {
          margin: 1em 0; padding: 0px;
        }
      }
    }
  }
`

const StyledArticle = styled.div`
  color: rgba(0, 0, 0, 0.8);
  display: grid;
  background: #e0ede8;
  padding-bottom: 15vh;

  #content-sources {
    display: grid;
    grid-template-columns: minmax(60px, auto) 7fr 60px 6fr minmax(60px, auto);
    > * {
      grid-column: 2;
      @media only screen and (max-width: ${totalWidth}px) {
        grid-column: 2/5;
      }
    }

    ul {
      list-style-type:none;
      margin:0;padding:0;
      li {
        margin-top: 1em;
        word-wrap: break-word;
      }
    }
  }
  
  #content-main {    
    margin-top: 30px;
    
    div:first-child {

      display: grid;
      grid-template-columns: 1fr 6fr 30px 6fr 1fr;
      @media only screen and (max-width: ${totalWidth}px) {
        grid-template-columns: minmax(30px, auto) 7fr 30px 6fr minmax(30px, auto);
      } 
  
      overflow-wrap: break-word;

      h1, h2, h3, h4, h5, h6 {
        font-weight: 600em;
      }

      h1 {
        font-size: calc(1em + .7vw);
      }
      
      h2 {
        font-size: calc(1em + .5vw);
      }
  
      h3 {
        font-size: calc(1em + .2vw);
      }
  
      h4 {
        font-size: calc(1em);
      }
  
      h5 {
        font-size: 1em;
      }
      
      p, ul {
        line-height: 2em;
        font-size: 18px;
      }

      figure {
        width: 100%;
        height: 100%;
        padding:0;
        margin:1em 0;

        figcaption {
          font-size: .9em;
          margin-top: 2px;
          color: rgba(0,0,0,0.4);
        }
        img {
          width: 100%;
        }
      }
      
      .funfact, blockquote {
        grid-column: 4;
        text-align: center;
        margin: auto;
        padding: 10px;
      }

      blockquote {
        font-style: italic;
        font-size: calc(1em + .7vw);
      }

      >:not(.funfact):not(blockquote){
        grid-column: 2; 
      }

      @media only screen and (max-width: ${totalWidth}px) {
        .funfact, blockquote {
          grid-column: 2/5; 
          width: 70%;
        }

        >:not(.funfact):not(blockquote){
          grid-column: 2/5; 
        }
      }
    }

    .funfact {
      background: #94AE89;
      color: white;
      max-width: 300px;
      a {
        color: white;
      }
    }

    iframe {
      width: 100%;
    }
  }
`

function Article(props) {
  const { _rawBody, title, mainImage, _rawSources, slug, toc, _rawDescription } = props

  return (
    <article className="framed">
      <NextPrev slug={slug} toc={toc} />
      <Header>
        <div id="header-info">
          <ContentTag type={"Artikkel"} />
          <h1>{title}</h1>
          <div id="description">
            {_rawDescription && <BlockContent blocks={_rawDescription || []} />}
          </div>
        </div>
        {mainImage && mainImage.asset && (
          <img id="main-image"
            src={imageUrlFor(buildImageObj(mainImage))
              .width(1000)
              .height(Math.floor((9 / 16) * 1000))
              .fit('crop')
              .url()}
            alt={mainImage.alt}
          />
        )}
      </Header>
      <StyledArticle>
        <div id="content-main">
          {_rawBody && <BlockContent blocks={_rawBody || []} />}
          {_rawSources && _rawSources.length > 0 &&
            <div id="content-sources">
              <h1>Kilder</h1>
              <BlockContent blocks={_rawSources} />
            </div>
          }
        </div>
      </StyledArticle>
    </article>
  )
}

export default Article
